export default __webpack_public_path__ + "1fc71b3e8f9f2711b4166b38fc483cb7.png";